import React from 'react';
import { useConsentPolicy } from "../../Components/DataRetention/ConsentPolicy";
import { getBrandName } from "../../Components/getBrandName";
import SEO from '../../../../SEO/Seo';
import { metaContent } from '../../../../SEO/metaContent';

const ConsentPolicy = () => {
  const { sections, generateContent } = useConsentPolicy();
  const { brandName} = getBrandName();

  return (<>
        {/* Meta tags  */}
        <SEO {...metaContent.consentPolicy} />

    <div className="privacy-policy-page">
      <div className="privacy-policy-heading text-center">
        <h2>Consent Preferences Policy</h2>
        <p className="text-muted" style={{fontSize:"0.8rem"}}>Take Control of Your Data Anytime, Anywhere</p>
        <p className="text-muted" style={{fontSize:"0.8rem"}}>Effective Date: <strong>July 3, 2025</strong></p>
        <p className="text-muted" style={{fontSize:"0.8rem"}}>Version: 1.0</p>
      </div>

      <div className="privacy-container">
        <div className="container py-5">
          <div className="row">
            <div className="col-12">
        <p>
          At {brandName}, consent is not a checkbox it's a right. We believe that your personal data should be used only with your explicit, informed, and voluntary permission. This Consent Preferences Policy explains how you can control the use of your data across our platform, in line with the Digital Personal Data Protection Act (DPDP), 2023.
          </p>
              {sections.map((section) => (
                <div key={section.id} className="mb-5">
                  <h5 className="fw-bold">{section.title}</h5>
                  <div className="text-muted">
                    {generateContent(section.id)}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
  );
};

export default ConsentPolicy;
